// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { useState, useEffect } from "react";
import { useBanner } from "../hooks/useBanner";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Form } from "react-bootstrap";
import "./EventBanners.css";

type EventBannerData = {
	_id: string;
	ImageUrl: string;
};

interface EventBannerProps {
	initialData: EventBannerData;
	onValueChange: (value: object) => void;
}

const EventBanners: React.FC<EventBannerProps> = ({
	initialData,
	onValueChange,
}) => {
	const { banners, bannersLoaded } = useBanner();
	const [selectedBanner, setSelectedBanner] = useState<EventBannerData>(initialData);
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const onBannerSelect = (e: any) => {
		setSelectedBanner({
			_id: e.target.id,
			ImageUrl: e.target.src,
		});
		onValueChange({
			_id: e.target.id,
			ImageUrl: e.target.src,
		});
	};

	return (
		<Container className="bannerContainer">
			<Row className="mb-3">
				<Col className="col-md-12">
					<h3>Banner</h3>
				</Col>
			</Row>

			<Row className="mb-3">
				{bannersLoaded &&
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					banners.map((banner: any) => (
						<Col className="col-md-1 mb-3" key={banner.id}>
							<Card
								border={
									selectedBanner && selectedBanner._id === banner.id
										? "primary"
										: ""
								}
								onClick={onBannerSelect}
							>
								<Card.Img id={banner.id} variant="top" src={banner.img} />
							</Card>
						</Col>
					))}
			</Row>
		</Container>
	);
}
export default EventBanners;
